/**
 * True when the app is on the main operational dashboard route.
 * Used so global notification banners match the dashboard regardless of
 * trailing slashes (e.g. `/dashboard/` vs `/dashboard`).
 */
export function isMainDashboardPath(pathname) {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  return p === "/dashboard" || p === "/";
}
